<template>
  <div>
    <div class="preview-dialog container view-parent">
      <div class="preview-content">
        <ProductHeader
          class="product-header-parent"
          :name="product.name" />
        <ProductInformationComponent
          :section="product.section"
          :radio="product"
          :isPreview="true"
          prefix="" />
        <ProductsBottomNavComponent
          :radio="product"
          :section="product.section"
          :currentRadio="product"
          :image="product.landscapeImagePath"
          @download="writeFile"
          :isPreview="true" />
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../ProductHeader.vue';
import ProductInformationComponent from '../ProductInformationComponent.vue';
import ProductsBottomNavComponent from '../ProductsBottomNavComponent.vue';
import AssetsApiService from '@/services/assetsServices/assetsApiService';
import ProductService from '@/services/productService';
import { KALTURA } from '@/constants/adminProduct';

export default {
  components: {
    ProductHeader,
    ProductInformationComponent,
    ProductsBottomNavComponent,
  },

  data() {
    return {
      product: {},
    };
  },

  created() {
    this.product = ProductService.getLocalProduct();

    if (this.product?.video?.entryId) {
      this.product.video.wid = KALTURA.WID;
      this.product.video.uiconfId = KALTURA.UICONF_ID;
      this.product.video.targetId = `kaltura_player_${this.product.video.entryId}`;
    }
  },

  methods: {
    async writeFile() {
      const fileName = this.product.dataSheetFilePath;
      const response = await AssetsApiService.getModelAsset(fileName);
      const blob = new Blob([response]);
      const link = document.createElement('a');

      link.download = fileName;
      link.href = window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
        }, 100);
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../../assets/common.less';

.container {
  padding: 1rem;
}

.preview-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: @gray-09;
  z-index: 1;
}

.product-placeholder {
  height: 90vh !important;
}
</style>